import React from 'react';
import { MdOutlineCancel } from 'react-icons/md';

/**
 * Shared tooltip container with arrow, title, and close button.
 * Wraps filter-specific content.
 */
const TooltipShell = React.forwardRef(({ title, onClose, children, className = '' }, ref) => (
    <div
        ref={ref}
        className={`absolute md:right-1/2 md:transform md:translate-x-1/2 top-full mt-2 w-64 p-3 bg-white rounded-lg shadow-xl z-50 border border-gray-200 ${className}`}
    >
        <div className="absolute -top-2 right-1/2 transform translate-x-1/2 w-4 h-4 bg-white border-t border-l border-gray-200 rotate-45"></div>
        <div className="flex items-center justify-between mb-2">
            <h3 className="text-sm font-bold">{title}</h3>
            <button onClick={onClose} aria-label="닫기">
                <MdOutlineCancel size={18} />
            </button>
        </div>
        {children}
    </div>
));

TooltipShell.displayName = 'TooltipShell';

/**
 * Shared apply/reset button pair for filter tooltips.
 */
export const FilterActions = ({ onReset, onApply }) => (
    <div className="flex justify-end space-x-2">
        <button
            onClick={onReset}
            className="px-2 py-1 text-xs text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
        >
            초기화
        </button>
        <button
            onClick={onApply}
            className="px-2 py-1 text-xs text-white bg-green-600 rounded-lg hover:bg-green-700"
        >
            적용
        </button>
    </div>
);

export default TooltipShell;
